import { Input } from "antd";
import type React from "react";
import { useCallback } from "react";
import type { ColumnComponentProperties } from "../../types";

export const RoundNumberColumn = (properties: ColumnComponentProperties) => {
  const updateFixtureCallback = useCallback(
    (value: string) => {
      properties.updateFixture({
        fixtureId: properties.fixtureId,
        upsertData: {
          roundNumber: value,
        },
      });
    },
    [properties],
  );

  const handlePressEnter = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      const target = e.target as HTMLInputElement;
      updateFixtureCallback(target.value);
    },
    [updateFixtureCallback],
  );

  const handleOnBlur = useCallback(
    (e: { target: { value: string } }) => {
      updateFixtureCallback(e.target.value);
    },
    [updateFixtureCallback],
  );

  if (properties.editMode) {
    return (
      <Input
        onBlur={handleOnBlur}
        disabled={properties.isUpdatePending}
        style={{ width: "100%" }}
        maxLength={30}
        onPressEnter={handlePressEnter}
        defaultValue={properties.value}
      />
    );
  }

  return properties.value;
};
